import { lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalPaper: {
    margin: 'auto',
    width: '90%',
    padding: 24,
    marginTop: '5vh',
    outline: 'none',
    backgroundColor: theme.palette.background.default,
    overflowY: 'scroll',
    height: '90vh'
  },
  datepickerContainer: {
    marginTop: 35
  },
  formContainer: {
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      marginTop: '1vh',
      marginBottom: '10vh',
      display: 'flex',
      flexDirection: 'column',
      height: '70vh'
    }
  },
  weekDaysContainer: {
    marginLeft: 40,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 0
    }
  },
  title: {
    marginLeft: 40,
    marginTop: 30,
    marginBottom: 25,
    paddingBottom: 4,
    position: 'relative',
    width: 'fit-content',
    '&:before': {
      content: "''",
      position: 'absolute',
      bottom: -3,
      left: 0,
      height: 2,
      width: '100%',
      backgroundColor:
        theme.palette.type === 'dark'
          ? lighten(theme.palette.background.default, 0.1)
          : lighten(theme.palette.secondary.dark, 0.7)
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      bottom: -3,
      left: 0,
      height: 2,
      width: '30%',
      backgroundColor: theme.palette.primary.main
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 60
    }
  },
  changesTitle: {
    marginLeft: 20
  },
  weekDaysRoot: {
    flex: 1
  },
  changesBox: {
    flex: 2,
    [theme.breakpoints.down('sm')]: {
      marginTop: -30,
      marginLeft: -18
    }
  },
  changeSelector: {
    marginLeft: 20
  },
  restrictionsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  restrictionItem: {
    borderLeft: '1px solid gray',
    paddingLeft: 16,
    marginTop: 20
  },
  inputLabel: {
    marginBottom: 8
  },
  separator: {
    marginTop: 32
  },
  restrictionTitleContainer: {
    position: 'relative',
    top: -10,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  restrictionTitle: {
    backgroundColor: theme.palette.background.default,
    paddingLeft: 8,
    paddingRight: 8,
    width: 'fit-content'
  },
  discountContainer: {
    marginBottom: 24
  },
  discountRow: {
    display: 'grid',
    gridTemplateColumns: '3fr 2fr 1fr',
    gap: 4,
    alignItems: 'flex-start'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 30,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 10,
      height: 60
    }
  },
  confirmButton: {
    marginLeft: 8
  },
  percentSign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700
  },
  inputNumber: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  validationCommentary: {
    margin: '.5rem 0 0 0',
    minHeight: 40
  },
  currencyContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
    marginLeft: 12
  },
  Buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  Button: {
    padding: 0
  },
  ButtonHide: {
    opacity: 0
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
